/**
 * Find Your Cocktail Quiz DataLayer Tracking
 * Tracks quiz_start and quiz_interaction events
 */

(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  // Track quiz_start event when user clicks Start button
  const startButton = document.querySelector('[data-change-step="1"][class*="button--solid"]');
  if (startButton) {
    startButton.addEventListener('click', () => {
      window.dataLayer.push({
        'event': 'quiz_start'
      });
    }, { once: true });
  }

  // Track quiz_interaction event (Step 1 - Occasion)
  const occasionStep = document.querySelector('.quiz__step--occasion');
  if (occasionStep) {
    const nextButton = occasionStep.querySelector('[data-change-step="1"]');
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        // Get selected occasion from active swiper slide
        const activeSlide = occasionStep.querySelector('.swiper-slide-active .quiz__slider-item');
        if (activeSlide) {
          const occasionTime = activeSlide.getAttribute('data-tag-label') || '';
          
          window.dataLayer.push({
            'event': 'quiz_interaction',
            'step_number': 'Step 1',
            'occasion_time': occasionTime
          });
        }
      });
    }
  }

  // Track quiz_interaction event (Step 2 - Flavour)
  // Track click on "Next" button in Step 3 (summary)
  const summaryStep3 = document.querySelector('.quiz__step--summary[data-step="3"]');
  
  if (summaryStep3) {
    const nextButton = summaryStep3.querySelector('[data-change-step="1"].button--solid');
    
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        // Get all selected flavours from Step 3 (summary) quiz__set elements
        const selectedFlavours = [];
        const flavourItems = summaryStep3.querySelectorAll('[data-set-item^="flavour-"]');
        
        flavourItems.forEach((item) => {
          const label = item.querySelector('.quiz__set-label');
          if (label && label.textContent.trim() !== '') {
            selectedFlavours.push(label.textContent.trim());
          }
        });

        window.dataLayer.push({
          'event': 'quiz_interaction',
          'step_number': 'Step 2',
          'selected_flavors': selectedFlavours.join('|')
        });
      });
    }
  }

  // Track quiz_interaction event (Step 3 - Category)
  // Track click on "Next" button in Step 4 (category)
  const categoryStep = document.querySelector('.quiz__step--category');
  
  if (categoryStep) {
    const nextButton = categoryStep.querySelector('[data-change-step="1"].button--solid');
    
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        // Get all selected categories (buttons with aria-pressed="true")
        const selectedCategories = [];
        const categoryButtons = categoryStep.querySelectorAll('.quiz__options-item[aria-pressed="true"]');
        
        categoryButtons.forEach((button) => {
          const label = button.getAttribute('data-tag-label') || button.querySelector('span')?.textContent.trim() || '';
          if (label) {
            selectedCategories.push(label);
          }
        });

        // Join all selected categories (if multiple) or use single preference
        const preferences = selectedCategories.length > 0 ? selectedCategories.join('|') : '';

        window.dataLayer.push({
          'event': 'quiz_interaction',
          'step_number': 'Step 3',
          'preferences': preferences
        });
      });
    }
  }

  // Track quiz_submit event
  // Track click on "Find my cocktail" button in Step 5 (summary)
  const summaryStep5 = document.querySelector('.quiz__step--summary[data-step="5"]');
  
  if (summaryStep5) {
    const findButton = summaryStep5.querySelector('[data-change-step="1"].button--solid');
    
    if (findButton) {
      findButton.addEventListener('click', () => {
        // Flag to prevent multiple event sends
        let eventSent = false;

        // Get occasion_time from Step 5 or Step 1
        let occasionTime = '';
        const occasionElement = summaryStep5.querySelector('[data-occasion]');
        if (occasionElement) {
          occasionTime = occasionElement.textContent.trim();
        } else {
          const occasionStep = document.querySelector('.quiz__step--occasion');
          if (occasionStep) {
            const activeSlide = occasionStep.querySelector('.swiper-slide-active .quiz__slider-item');
            if (activeSlide) {
              occasionTime = activeSlide.getAttribute('data-tag-label') || '';
            }
          }
        }

        // Get selected_flavors from Step 5 (summary)
        const selectedFlavours = [];
        const flavourItems = summaryStep5.querySelectorAll('[data-set-item^="flavour-"]');
        
        flavourItems.forEach((item) => {
          const label = item.querySelector('.quiz__set-label');
          if (label && label.textContent.trim() !== '') {
            selectedFlavours.push(label.textContent.trim());
          }
        });

        // Get preferences from Step 4 (category)
        const selectedCategories = [];
        if (categoryStep) {
          const categoryButtons = categoryStep.querySelectorAll('.quiz__options-item[aria-pressed="true"]');
          categoryButtons.forEach((button) => {
            const label = button.getAttribute('data-tag-label') || button.querySelector('span')?.textContent.trim() || '';
            if (label) {
              selectedCategories.push(label);
            }
          });
        }
        const preferences = selectedCategories.length > 0 ? selectedCategories.join('|') : '';

        // Function to send quiz_submit event (only once)
        const sendQuizSubmitEvent = (recommendedCocktail = '') => {
          if (eventSent) return;
          eventSent = true;
          
          window.dataLayer.push({
            'event': 'quiz_submit',
            'occasion_time': occasionTime,
            'selected_flavors': selectedFlavours.join('|'),
            'preferences': preferences,
            'recommended_cocktail': recommendedCocktail
          });
        };

        // Try to get recommended_cocktail from Step 7 (results) immediately
        const resultsStep = document.querySelector('.quiz__step--results');
        if (resultsStep) {
          const matchTitle = resultsStep.querySelector('[data-match-title]');
          if (matchTitle && matchTitle.textContent.trim() !== '') {
            // If already available, send event immediately
            sendQuizSubmitEvent(matchTitle.textContent.trim());
            return;
          }
        }

        // If not available, wait for it to be populated
        // Observe Step 7 (results) for when it becomes active and data is populated
        const resultsStepObserver = new MutationObserver((mutations) => {
          if (eventSent) {
            resultsStepObserver.disconnect();
            return;
          }
          
          const resultsStep = document.querySelector('.quiz__step--results');
          if (resultsStep && resultsStep.classList.contains('quiz__step--active')) {
            const matchTitle = resultsStep.querySelector('[data-match-title]');
            if (matchTitle && matchTitle.textContent.trim() !== '') {
              sendQuizSubmitEvent(matchTitle.textContent.trim());
              resultsStepObserver.disconnect();
            }
          }
        });

        // Start observing
        if (resultsStep) {
          resultsStepObserver.observe(resultsStep, {
            attributes: true,
            attributeFilter: ['class'],
            childList: true,
            subtree: true
          });
        }

        // Also observe the match-title element directly if it exists
        const matchTitleElement = document.querySelector('[data-match-title]');
        if (matchTitleElement) {
          const matchTitleObserver = new MutationObserver((mutations) => {
            if (eventSent) {
              matchTitleObserver.disconnect();
              return;
            }
            
            if (matchTitleElement.textContent.trim() !== '') {
              sendQuizSubmitEvent(matchTitleElement.textContent.trim());
              matchTitleObserver.disconnect();
              resultsStepObserver.disconnect();
            }
          });

          matchTitleObserver.observe(matchTitleElement, {
            childList: true,
            subtree: true,
            characterData: true
          });

          // Timeout fallback - send event after 5 seconds even if cocktail name is not available
          setTimeout(() => {
            if (!eventSent) {
              sendQuizSubmitEvent('');
            }
            matchTitleObserver.disconnect();
            resultsStepObserver.disconnect();
          }, 5000);
        } else {
          // If element doesn't exist yet, send event without recommended_cocktail
          sendQuizSubmitEvent('');
        }
      });
    }
  }

})();
